import * as Type from './type';
import { message } from 'antd';
import RPC from 'api';
import ability from '../../../ability';

export const updateRadarLinkState = (data) => ({
    type: Type.UPDATE_RADARLINK_STATE,
    data
});

export const updateMapPara = (data) => ({
    type: Type.UPDATE_RADARLINK_MAPPARA,
    data
});

export const updateRealSize = (data) => ({
    type: Type.UPDATE_RADARLINK_REALSIZE,
    data
});

/**MapPara */
export const getMapParaData = (refresh) => (dispatch, getState, resolve) => {
    let {
        publicState: {
            $t
        }
    } = getState();
    RPC.ConfigManager.getConfig('MapPara').then(json => {
        dispatch(updateMapPara(json));
        if (refresh) {
            message.success($t('com.Operateingsuccess'));
        }
        resolve(json);
    }).catch(err => {
        message.error($t('com.Operateingfailure'));
    });
};
export const setMapParaData = (newData) => (dispatch, getState, resolve) => {
    let {
        publicState: {
            $t
        }
    } = getState();
    RPC.ConfigManager.setConfig('MapPara', newData).then(() => {
        dispatch(updateMapPara(newData));
        message.success($t('com.Operateingsuccess'));
        resolve();
    }).catch(err => {
        message.error($t('com.Operateingfailure'));
    });
};
export const getDefaultMapParaData = () => (dispatch, getState, resolve) => {
    let {
        publicState: {
            $t
        }
    } = getState();
    RPC.ConfigManager.getDefault('MapPara').then(json => {
        dispatch(updateMapPara(json));
        resolve(json);
        message.success($t('com.OperateingSuccessTip'));
    }).catch(err => {
        message.error($t('com.Operateingfailure'));
    });
};
export const calculateRealSize = (Distance, PixelLine, Channel = 0) => (dispatch, getState, resolve) => {
    let {
        publicState: {
            $t
        }
    } = getState();
    RPC.RadarAdaptor.calculateRealSize(Distance, PixelLine, Channel = 0).then(json => {
        dispatch(updateRealSize(json));
        resolve(json);
    }).catch(err => {
        message.error($t('com.Operateingfailure'));
    });
};